import { render, staticRenderFns } from "./wait_for.vue?vue&type=template&id=b5524f00&"
import script from "./wait_for.vue?vue&type=script&lang=js&"
export * from "./wait_for.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports